<template>
  <div>
    <a-select
      :placeholder="selectData.hint"
      :value="value"
      @change="handleSelect"
    >
      <a-select-option
        v-for="option in JSON.parse(selectData.configDataDesc)"
        :key="option.key"
        :value="option.key"
      >
        {{ option.name }}
      </a-select-option>
    </a-select>
    <div v-if="selectId">
      <div
        v-for="list in JSON.parse(selectData.configViewDesc).attach_label"
        :key="list.key"
      >
        {{ list.label }}:
        {{ getProductionName(
          list,
          JSON.parse(selectData.configDataDesc),
        ) }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    selectData: {
      type: Object,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data(){
    return {
      selectId: '',
    };
  },
  watch: {
    value: {
      handler(val){
        console.log('TCL: value -> val', val);
        this.value = val;
        this.selectId=val;
      },
      immediate: true,
    },
  },
  methods: {
    // type:6
    getProductionName(list, configDataDesc) {
      let data;
      const selectData = configDataDesc.find((item) => item.key === this.selectId);
      if(Array.isArray(selectData[list.key])){
        data= selectData[list.key].map((item)=>{
          return item.name;
        }).join();
      }else{
        data=selectData[list.key];
      }
      console.log('data', data);
      return data;
    },
    // 选择下拉框
    handleSelect(val){
      console.log('TCL: handleSelect -> val', val);
      this.selectId=val;
      this.$emit('change', val);
    },
  },
};
</script>
